import { createAction } from '@reduxjs/toolkit';
export const getScreenSettingsByScreenNameTableName = createAction('settings/getScreenSettingsByScreenNameTableName');
export const resetScreenSettingsStatus = createAction('settings/resetScreenSettingsStatus');
export const createScreenSettings = createAction('settings/createScreenSettings');
export const updateScreenSettings = createAction('settings/updateScreenSettings');
export const screenSettingsResolved = createAction('settings/screenSettingsResolved');
export const screenSettingsRejected = createAction('settings/screenSettingsRejected');
export const addDefaultColumnsToScreenSettings = createAction('settings/addDefaultColumnsToScreenSettings');
